import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';

const { registerReducer } = useStorymapStore();

export class CollaboratorRemoved extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'CollaboratorRemoved';

    public constructor(public userId: string) {
        super(CollaboratorRemoved.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: CollaboratorRemoved): void => {
    state.collaborators = state.collaborators.filter(x => x.userId != action.userId);
};

//@ts-ignore
registerReducer(CollaboratorRemoved.ACTION_TYPE, reducer);